import { Switch, Route, Redirect } from "react-router-dom";
import { connect } from "react-redux";
import { notification } from "antd";
import { fetchUserInfoAsync } from "../redux/user/user.actions";
import { socketServer } from "../assets/socketConnection";
import "./App.css";
import { AppStyled } from "./app.styles";
// import WithMainContainer from "../HOC/withMainContainer/WithMainContainer.HOC";
import socket from "../assets/socketConnection";
import Fixed from "../containers/fixed/fixed.container";
import AlertNotif from "../containers/alertNotif/alertNotif.component";
import Login from "../pages/login/login.component.jsx";
import NoLogginHome from "../pages/noLogginHome/noLogginHome.component";
import AlertPage from "../components/alertPage/alertPage.component";
import { createStructuredSelector } from "reselect";
import { selectUserToken } from "../redux/user/user.selectors";
import CoreApp from "../pages/coreApp/coreApp.component";
import { ThemeProvider } from "styled-components";
import theme from "../styledTheme/styledTheme";
// import socket from "../assets/socketConnection";
import { useState, useEffect } from "react";
import SocketConnectionStatus from "../containers/SocketConnectionStatus/SocketConnectionStatus";
import useMediaQuery from "../hooks/useMediaQuery";
// import { Animated } from "react-animated-css";
import packageJson from "../../package.json";
import { setQueryObject, setUserCookie } from "../redux/login/login.actions";
import { selectUserCookie } from "../redux/login/login.selectors";
import { fetchAllReqsSuccess } from "../redux/reqs/reqs.actions";
function App({
  fetchUserInfoAsync,
  selectUserToken,
  setQueryObject,
  setUserCookie,
  selectUserCookie,
  fetchAllReqsSuccess,
}) {

  let size = useMediaQuery();
  // console.log({ size });
  console.log(packageJson.version);
  useEffect(() => {
    socket.emit("get_my_action_required", "");
    socket.on("response_my_action_required", (data) => {
      console.log("action__req", data);
    });
    socket.emit("get_action_required_places", "");
    socket.on("response_action_required_places", (data) => {
      console.log("action__req", data);
    });
    socket.emit("get_terms", "");
    socket.on("response_terms", (data) => {
      console.log(
        "APP VERSION : ",
        packageJson.version >= data[0].app_version_webapp
      );
      if (packageJson.version >= data[0].app_version_webapp) {
        console.log("Version Is Up To Date");
      } else {
        console.log("You Need To Use Newer Version");
      }
    });
    const detectMob = () => {
      const toMatch = [
        /Android/i,
        /webOS/i,
        /iPhone/i,
        /iPad/i,
        /iPod/i,
        /BlackBerry/i,
        /Windows Phone/i,
      ];
      return toMatch.some((toMatchItem) => {
        return navigator.userAgent.match(toMatchItem);
      });
    };
    const isMobile = detectMob();
    let ClirentInformation = {
      type: "web",
      version: packageJson.version,
      userAgent: navigator.userAgent,
      socketServer: socketServer,
      platform: navigator.oscpu,
      isMobile: isMobile,
      appBrowser: navigator.appCodeName,
    };
    console.log("userAgent", ClirentInformation);
    socket.emit("report_client_information", ClirentInformation);
  }, []);
  const openNotification = (data) => {
    const args = {
      message: data.title,
      description: data.content,
      duration: 0,
    };
    notification.open(args);
  };
  useEffect(() => {
    socket.on("live_messages", (data) => {
      console.log("live", data);
      if (data) {
        openNotification(data);
      }
    });
  });
  useEffect(() => {
    function QueryStringToJSON() {
      var pairs = window.location.search.slice(1).split("&");
      var result = {};
      pairs.forEach(function (pair) {
        pair = pair.split("=");
        result[pair[0]] = decodeURIComponent(pair[1] || "");
      });

      return JSON.parse(JSON.stringify(result));
    }

    const query_string = QueryStringToJSON();
    setQueryObject(query_string);
    console.log("queryString", query_string);
  }, []);

  useEffect(() => {
    console.log("hodhod");
    window.onerror = function (msg, source, lineNo, columnNo, error) {
      // alert("Message : " + msg );
      // alert("url : " + url );
      // alert("Line number : " + line );
      console.log("hodhod", msg, source, lineNo, columnNo, error);
    };
  }, []);

  useEffect(() => {
    // function setCookie(cname, cvalue, exdays) {
    //   const d = new Date();
    //   d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
    //   let expires = "expires=" + d.toUTCString();
    //   document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    // }
    function getCookie(cname) {
      let name = cname + "=";
      let decodedCookie = decodeURIComponent(document.cookie);
      let ca = decodedCookie.split(";");
      for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === " ") {
          c = c.substring(1);
        }
        if (c.indexOf(name) === 0) {
          return c.substring(name.length, c.length);
        }
      }
      return "";
    }
    setUserCookie(getCookie("token"));
    console.log("cookie", getCookie("token"));
    // function checkCookie() {
    //   setUserCookie(getCookie("token"));
    //   if (selectUserCookie) {
    //     // window.location.href = `/app2/reqs`;
    //     console.log("cookie", selectUserCookie);
    //   } else {
    //     if (!selectUserCookie) {
    //       setCookie("token", selectUserToken, 30);
    //     }
    //   }
    // }
  }, []);

  // useEffect(() => {
  //   socket.emit('get_insurance_offers',{})
  //   socket.on("response_request_offers", (data) => {
  //     console.log("bime", data);
  // });

  // useEffect(() => {
  //   alert("hi2");
  //   // var token = localStorage["token"];

  //   // const usertoken = {
  //   //   token:
  //   //     "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJtb2JpbGUiOiIwOTEwMjExOTExOCIsImVtYWlsIjpudWxsLCJfaWQiOiI1ZjI0ZjlmZGMyZjcwYTIzODg3YmM2MTMiLCJJc01lbWJlciI6dHJ1ZSwiaWF0IjoxNjExOTkwMTc0LCJleHAiOjE2MTQ1ODIxNzR9.qn3W8GKfKvb7tco3au8W4uLMd4-aV5VbIwFczqQlWNM",
  //   // };
  //   socket.on("connect", (data) => {
  //     alert("hi2");
  //     console.log("SOCKET CONNECTED");
  //     socket.emit("authenticate", { token: selectUserToken });
  //     // const xxxx = !!selectUserToken;
  //     // console.log(xxxx);
  //     debugger;
  //     fetchUserInfoAsync(socket);
  //   });
  //   socket.on("disconnect", (data) => {
  //     // alert("disconnect");
  //     console.log("SOCKET DISCONNECTED");
  //   });

  //   // socket.on("response_notif", ({ type, message }) => {
  //   //   alert("notif");

  //   //   // setMessage(message);
  //   //   // setShow(true);

  //   //   //   switch (type) {
  //   //   //     case 0:
  //   //   //       alert("0");
  //   //   //       // handle_alert(message);
  //   //   //       break;
  //   //   //     default:
  //   //   //       break;
  //   //   //   }
  //   // });

  //   socket.on("response_notif_request_load", (data) => {
  //     alert("new request ");
  //     console.log(data);
  //     // debugger;

  //     // updateReqResponse(data);
  //     // if(data.type )
  //     // alert("hiasdf");
  //   });

  //   // return () => {
  //   //   cleanup
  //   // }
  // }, [selectUserToken]);
  const [isUserValid, setIsUserValid] = useState(true);

  useEffect(() => {
    const data = {};
    fetch(`${socketServer}get_load_requests_nologin`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((res) => {
        console.log("nologgingdata", res);
        fetchAllReqsSuccess(res);
      })
      .catch((err) => console.log(err.message));
  }, []);

  return (
    <ThemeProvider theme={{ ...theme, windowWidth: size }}>
      <AppStyled className="App">
        <AlertPage />
        <AlertNotif />
        {/* <Animated
        animationIn="bounceInRight"
        animationOut="bounceOutRight"
        animationInDuration={1000}
        animationOutDuration={2500}
        isVisible={true}
        className="animated position-relative"
      >
          <div className="text-center shadow">
            ارتباط شما با سرور برقرار نیست
          </div>
      </Animated> */}

        <Switch>
          <Route path="/app2/login" component={Login} />
          <Route  path="/app2/without" component={NoLogginHome} />
          <Route>
            <Fixed />
            <Switch>
              {selectUserToken && isUserValid ? (
                <>
                  <SocketConnectionStatus />
                  <CoreApp setIsUserValid={setIsUserValid} />
                </>
              ) : (
                <Redirect to="/app2/login" />
              )}
            </Switch>
          </Route>
        </Switch>
      </AppStyled>
    </ThemeProvider>
  );
}

const mapStateToProps = createStructuredSelector({
  selectUserToken: selectUserToken,
  selectUserCookie: selectUserCookie,
});

const mapDispatchToProps = (dispatch) => ({
  fetchUserInfoAsync: (x) => dispatch(fetchUserInfoAsync(x)),
  setQueryObject: (x) => dispatch(setQueryObject(x)),
  setUserCookie: (x) => dispatch(setUserCookie(x)),
  fetchAllReqsSuccess: (x) => dispatch(fetchAllReqsSuccess(x)),
});

export default connect(mapStateToProps, mapDispatchToProps)(App);
